var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hotDestinations.length > 0)?_c('div',{attrs:{"data-testid":"hot-destinations-view"}},[_c('HotDestinationsGrid',{attrs:{"cities":_vm.hotDestinations}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }